// eslint-disable-next-line
import { useCurrentUserQuery } from "../../api/queries/useUserQuery";

const action = {
  or: "some",
  and: "every",
};

export function PrivilegesGuard({
  children,
  requiredPrivileges,
  logical = "and",
  renderFallback,
  renderLoadingFallback,
}) {
  const { data: user, isLoading } = useCurrentUserQuery();

  if (isLoading) {
    return renderLoadingFallback ? renderLoadingFallback() : null;
  }

  const hasRequiredPrivileges = requiredPrivileges[action[logical]](
    (privilege) => user.privileges.includes(privilege),
  );

  return hasRequiredPrivileges
    ? children
    : renderFallback
    ? renderFallback(user)
    : null;
}
